import { TRegularInfrastructureItem } from '../../types/map';
import { getConstructionYears } from './getConstructionYears';
import { getMapYears } from './getMapYears';

export function hasFutureObjects(infrastructureItems: TRegularInfrastructureItem[]) {
  const mapYears = getMapYears();

  return infrastructureItems.some(item => {
    if ('constructionYearFrom' in item) {
      const constructionYears = getConstructionYears(item);

      return constructionYears.some(constructionYear => mapYears.includes(constructionYear));
    }

    return false;
  });
}
